import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ToastService {

  toasts = signal<{ message: string; type: string }[]>([]);

  showToast(message: string, type: string = 'success'): void {
    this.toasts.set([...this.toasts(), { message, type }]);

    setTimeout(() => {
      this.toasts.set(this.toasts().slice(1));
    }, 5000);
  }
}
